var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"La3",style:({
  gridTemplateColumns: _vm.ratio
})},[_c('div',{staticClass:"La3_left",style:(_vm.styleLeft)},[_vm._t("left")],2),_c('div',{staticClass:"La3_center",style:(_vm.styleCenter)},[_vm._t("center")],2),_c('div',{staticClass:"La3_right",style:(_vm.styleRight)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }